import React from 'react';

type BackupArtVariant = 'pending' | 'drive';

/** Empty pending list, or the Drive connect illustration. */
export function BackupArt({ variant }: { variant: BackupArtVariant }) {
  return (
    <svg className={`bk-art bk-art--${variant}`} viewBox="0 0 420 230" aria-hidden="true">
      <rect className="bk-art__sky" width="420" height="230" rx="28" />
      <circle className="bk-art__sun" cx="348" cy="42" r="16" />
      <circle className="bk-art__cloud" cx="64" cy="48" r="10" />
      <circle className="bk-art__cloud" cx="82" cy="42" r="14" />
      <path
        className="bk-art__hill"
        d="M0 148c54-28 86 12 140-6 42-14 68 18 116-4 32-14 52 8 98-12 16-8 38 6 66-10v120H0z"
      />
      <path className="bk-art__hill2" d="M0 186c66-20 98 14 158-4 50-14 72 16 196-10v58H0z" />
      {variant === 'pending' ? <PendingMotif /> : <DriveMotif />}
    </svg>
  );
}

function PendingMotif() {
  return (
    <g>
      <path
        className="bk-art__blob"
        d="M118 150h132a36 36 0 0 0-8-70 46 46 0 0 0-88-8 34 34 0 0 0-36 78z"
      />
      <circle className="bk-art__check" cx="196" cy="118" r="18" />
      <path
        d="M187 118l6 6 12-14"
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect className="bk-art__phone" x="286" y="92" width="52" height="86" rx="12" />
      <rect className="bk-art__glass" x="294" y="104" width="36" height="52" rx="6" />
    </g>
  );
}

function DriveMotif() {
  return (
    <g>
      <path
        className="bk-art__blob"
        d="M108 154h150a40 40 0 0 0-10-78 50 50 0 0 0-96-6 36 36 0 0 0-44 84z"
      />
      <path
        className="bk-art__arrow"
        d="M168 128v28M168 128l-10 10M168 128l10 10"
        fill="none"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fill="#4285F4" d="M248 112l16 26h-32z" />
      <path fill="#34A853" d="M232 138h32l-16 26z" />
      <path fill="#FBBC04" d="M264 138h32l-16 26z" />
      <rect className="bk-art__phone" x="300" y="96" width="48" height="80" rx="12" />
      <rect className="bk-art__glass" x="308" y="108" width="32" height="48" rx="6" />
    </g>
  );
}
